import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('pages.RequestFormPage.selectors.pageSelectors', {
    newRequestDocumentTitleText: 'New {requestName}',
});
